import { RemoteUnlinkPersonFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesPersons } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUnlinkPersonFromEntity =
  (): RemoteUnlinkPersonFromEntity => {
    return new RemoteUnlinkPersonFromEntity(
      makeApiUrlEntitiesPersons(),
      makeAxiosHttpClient(),
    );
  };
